import React from "react";
import type { RouteObject } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { KashAssessmentQuizScreen } from "./pages/kash-assessment/quiz.screen";
import { KashAssessmentCompleteScreen } from "./pages/kash-assessment/complete.screen";
import { AssessmentPreviewScreen } from "./pages/assessment-preview/preview.screen";

/**
 * MDRT Module Route Configuration
 *
 * This configuration provides the routing structure for the MDRT module,
 * including KASH Assessment functionality.
 */

export const routesMdrt: any[] = [
  {
    path: "kash-assessment-quiz/:assignmentId",
    element: (React as any).createElement(KashAssessmentQuizScreen),
  },
  {
    path: "kash-assessment-quiz/:assignmentId/complete",
    element: (React as any).createElement(KashAssessmentCompleteScreen),
  },
  {
    path: "assessment-preview",
    element: (React as any).createElement(AssessmentPreviewScreen),
  },
  // Additional MDRT routes can be added here as the module expands
];

export default routesMdrt;
